import { render, staticRenderFns } from "./Fishbonediagram.vue?vue&type=template&id=268e7ffb&scoped=true&"
import script from "./Fishbonediagram.vue?vue&type=script&lang=js&"
export * from "./Fishbonediagram.vue?vue&type=script&lang=js&"
import style0 from "./Fishbonediagram.vue?vue&type=style&index=0&id=268e7ffb&scoped=true&lang=css&"
import style1 from "./Fishbonediagram.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268e7ffb",
  null
  
)

export default component.exports